import React from 'react'
import colors from '../styles/colors'
import { TouchableOpacity } from 'react-native'
import MSFESIcon from './MSFESIcon'

export const MSFESTristateCheckbox = (props) => {
  const color =
    props.checkState === true
      ? colors.controlSelected
      : props.checkState === false
      ? colors.redBase
      : colors.labelGray

  const status =
    props.checkState === true
      ? 'checked'
      : props.checkState === false
      ? 'unchecked'
      : 'indeterminate'

  const style = {
    borderRadius: 4,
    width: 24,
    height: 24,
    backgroundColor: color,
    justifyContent: 'center',
    alignItems: 'center'
  }

  return (
    <TouchableOpacity onPress={props.onPress} style={[style, props.style]}>
      <MSFESIcon
        style={{ justifyContent: 'center', alignItems: 'center' }}
        name={
          status == 'checked'
            ? 'check'
            : status == 'unchecked'
            ? 'times'
            : 'square'
        }
        size={18}
        color={status == 'indeterminate' ? colors.labelGray : colors.white}
      />
    </TouchableOpacity>
  )
}
